import { Component, OnInit, ViewChild, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MessageError } from 'base-models';
import { AlertType } from 'base-models';
import { Site, Panel, PanelType } from 'solar-bo';
import { SolarBaseComponent } from '@solar/solar/solar-base/solar-base.component';
import { DialogdeleteComponent } from 'basecomponents';

import { AppInjector } from 'base-models';
import { ErrorcontrolService } from 'basecomponents';
import { ProfileEnum  } from 'solar-bo';
import { PanelTypeEditDlgComponent } from '../../panel/panel-edit/paneltype-edit-dlg.component';


@Component({
  selector: 'app-panelstype-list',
  templateUrl: './site-panelstype-list.component.html',
  styleUrls: ['./site-panelstype-list.component.scss']
})
export class SitePanelsTypeListComponent extends SolarBaseComponent implements OnInit, OnChanges {
  
  @Input() site:Site;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  
  profileenum:any=ProfileEnum;
  displayedColumns = ['brand','model','serial','type','power','efficiency','vmp','voc', 'actions'];
  dataSource = new MatTableDataSource<any>(this.listOriginal);
  filteredList: any;
  highlightedRows = [];



  public constructor() {  
    super();
    const injector = AppInjector.getInjector();   
    //this.dialog = injector.get(MatDialog);
    

  }

  ngOnInit() {
     this.getList();   
  }

  ngOnChanges(changes: SimpleChanges) {
    const typeChange = changes['site'];
    if ((typeChange && !typeChange.firstChange) && typeChange.currentValue != undefined) {
      this.getList();
    }
  }

  refresh(){
    this.getList();
  }

  getList(): void {
    if (!this.site){
      return;
    }
    this.listerrmessage = "";
    this.loading = true;

    let res=this.solarService.siteGetPanelsTypes(this.site.id);
    res.then(reslist => this.getListhandleresult(reslist));
    res.catch(err => this.getListhandleError(err));
    
  }

  getListhandleresult(newlist: any[]) {
    console.log('getListhandleresult', newlist);
    this.listerrmessage = '';
    this.loading = false;
    this.listOriginal = newlist;
    this.configsource();
    this.alertmessage = null;
  }
  getListhandleError<T>(err: any) {
    console.log("getListhandleError");
    this.loading = false;
    this.alertmessage=ErrorcontrolService.basichandleError("", err);
  }

  hasDatasheet(panelType:any){
    if (panelType && panelType.info && panelType.info.datasheet){
      return true;
    }
  
    return false;
  }

  configsource() {
    this.dataSource = new MatTableDataSource<any>(this.listOriginal);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  uiisdeletable(element: any) {
    return true;
  }

  itemSelected(item: Site) {
    this.selectedItemEvent.next(item);
  }

  openDialogDeletePanel(model) {
    let dialogRef = this.openDialogDelete("Delete Panel", "Do you want to delete panel: " + model.brand + " " + model.model, model);
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => this.deleteHandler(model,dialogRef));
  }

  deleteHandler(model: Panel, dialogRef: MatDialogRef<DialogdeleteComponent>, ) {
    const dlgComp = dialogRef.componentInstance;
    dlgComp.lockdeletebtn();
    dialogRef.close();
    this.loadinglist = true;
    this.alertmessage = new MessageError(AlertType.Warning, "Deleting panel, please wait");
    this.solarService.sitePanelsTypesDeleteById(model.id)
      .subscribe(() => 
          this.deleteSucessHandler(model.id)
          , err => this.handleError(err, "Error deleting panel "));
  }


  deleteSucessHandler(id: string) {
    const index = this.listOriginal.findIndex(el => el.id == id, 0);
    if (index > -1) {
      this.listOriginal.splice(index, 1);
      this.configsource();
    }
    this.handleSuccesLoad("Panel deleted");
  }

  addpdfsheet(row){
    this.showmessage("Not implemented yet");
  }

 /**
   * New Site
   * @param itemToEdit 
   */
  newPanel(itemToEdit?:PanelType){    
    let dialogRef: MatDialogRef<PanelTypeEditDlgComponent>; 
    dialogRef = PanelTypeEditDlgComponent.openModal(this.dialog,itemToEdit);   
    dialogRef.componentInstance.saveEvent.subscribe((panelSaved) => this.panelSaveEventHandler(dialogRef,panelSaved));
  }

  panelSaveEventHandler(dialogRef: MatDialogRef<any>, panelSaved: PanelType) {    
    const index = this.listOriginal.findIndex(d => d.id === panelSaved.id);
    if (index != -1) {
      this.listOriginal[index] = panelSaved;
    } else {
      this.listOriginal.push(panelSaved);
      this.configsource();
    }
  }

}

